import axios from "axios";
// const apiUrl = 'http://192.168.99.105:10011/api/'
// const apiUrl = 'http://192.168.99.250:11112/api/'
const apiUrl = "https://lelezytbapi.jsjy.fun/api/";
// const apiUrl = "http://192.168.99.15:10020/api/";
// const apiUrl = "http://192.168.99.15:10012/api/";
const contenttype = "application/x-www-form-urlencoded";
import { Message } from "element-ui";
import md5 from "js-md5";
import moment from "moment";

//临时token 用于调查问卷
const smartToken =
  "4TCjsjs/GdnhAdrXlFb7124gw30aA1Rl8JHGwwo5A+FxJQfiMKEmC9QgUS/+rIA/QHMnI8pDE7XHa0GZNdBVRw==";
async function get(url, data, content) {
  let token = md5(
    md5(moment().format("YYYYMMDDHHmm")).toUpperCase() + "Le@22"
  ).toUpperCase();
  let res = await axios({
    method: "GET",
    url: apiUrl + url,
    headers: {
      "Content-Type": content ? content.content : contenttype,
      Token: token,
      "SmartCampus-Token": localStorage.getItem("smartCampusToken")
        ? localStorage.getItem("smartCampusToken")
        : smartToken
    },
    params: data
  });
  if (res.data.code === 0) {
    if (res.data.message) {
      return {
        data: res.data.data,
        headers: res.headers,
        message: res.data.message
      };
    } else {
      return { data: res.data.data, headers: res.headers };
    }
  } else {
    Message.error(res.data.message);
  }
}
async function post(url, data, content) {
  console.log("打印这个content", content);
  let token = md5(
    md5(moment().format("YYYYMMDDHHmm")).toUpperCase() + "Le@22"
  ).toUpperCase();
  let res = await axios({
    method: "POST",
    url: apiUrl + url,
    headers: {
      "Content-Type": content ? content.content : contenttype,
      Token: token,
      "SmartCampus-Token": localStorage.getItem("smartCampusToken")
        ? localStorage.getItem("smartCampusToken")
        : smartToken
    },
    data: data
  });
  console.log("打印这个res", res);
  if (res.data.code === 0) {
    return { data: res.data.data, code: res.data.code };
  } else {
    console.log("post接口错误");
    Message.error(res.data.message);
  }
}
async function del(url, data, content) {
  let res = await axios({
    url: apiUrl + url,
    data: data,
    method: "DELETE",
    dataType: "json",
    headers: {
      "Content-Type": content ? content.content : contenttype,
      "SmartCampus-Token": localStorage.getItem("smartCampusToken")
        ? localStorage.getItem("smartCampusToken")
        : smartToken
    }
  });
  console.log("打印删除的res111", res);
  if (res.data.code === 0) {
    return { data: res.data.data, code: res.data.code };
  } else {
    console.log("delete接口错误");
    Message.error(res.data.message);
  }
}
async function put(url, data, content) {
  console.log("打印这个content", content);
  let token = md5(
    md5(moment().format("YYYYMMDDHHmm")).toUpperCase() + "Le@22"
  ).toUpperCase();
  let res = await axios({
    method: "PUT",
    url: apiUrl + url,
    headers: {
      "Content-Type": content ? content.content : contenttype,
      Token: token,
      "SmartCampus-Token": localStorage.getItem("smartCampusToken")
        ? localStorage.getItem("smartCampusToken")
        : smartToken
    },
    data: data
  });
  console.log("打印这个res", res);
  if (res.data.code === 0) {
    return { data: res.data.data, code: res.data.code };
  } else {
    console.log("put接口错误");
    Message.error(res.data.message);
  }
}
export default {
  get,
  post,
  del,
  put,
  apiUrl
};



// WEBPACK FOOTER //
// ./src/api/api.js